import {RefObject, useEffect} from "react";

const useOnFocusOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: Event) => void
): void => {
  useEffect(() => {
    const listener = (event: FocusEvent) => {
      const el = ref?.current;
      if (!el || el.contains((event?.target as Node) || null)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("focusin", listener);

    return () => {
      document.removeEventListener("focusin", listener);
    };
  }, [ref, handler]);
};

export default useOnFocusOutside;
